import { Component, inject } from '@angular/core';
import { DsTooltipDirectiveModule, TooltipConfig } from '@bmw-ds/components';

import { TracingService } from '../../../../backend/tracing.service';
import { useI18n } from '../../../i18n/services/i18n.service';
import { VersionComponent } from '../../../version/version.component';

@Component({
  selector: 'cdf-app-info',
  imports: [VersionComponent, DsTooltipDirectiveModule],
  template: `
    <div class="text-label text-neutral cursor-default">
      <cdf-version [ds-tooltip]="i18n('version.tooltip')" [dsTooltipConfig]="tooltipConfig" />
      <div [ds-tooltip]="i18n('session.id.tooltip')" [dsTooltipConfig]="tooltipConfig">
        @if (tracingService.sessionId() === '') {
          <i>n/a</i>
        } @else {
          <span class="session-id text-smallprint">{{ tracingService.sessionId() }}</span>
        }
      </div>
    </div>
  `,
  styleUrl: 'app-info.component.scss',
})
export class AppInfoComponent {
  protected readonly tracingService = inject(TracingService);
  protected readonly i18n = useI18n();

  protected readonly tooltipConfig: Partial<TooltipConfig> = { origin: 'left' };
}
